import React, { FC, CSSProperties } from 'react';
import clsx from 'clsx';

import styles from './Skeleton.module.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  ml?: string | number;
  mr?: string | number;
  mt?: string | number;
  mb?: string | number;
  mx?: string | number;
  my?: string | number;
  className?: string;
  borderRadius?: string | number;
}

const Skeleton: FC<SkeletonProps> = ({ width, height, ml, mr, mt, mb, mx, my, className, borderRadius }) => {
  const style: CSSProperties = {};

  if (width !== undefined) style.width = width;
  if (height !== undefined) style.height = height;
  if (borderRadius !== undefined) style.borderRadius = borderRadius;

  // Handle margins: mx/my take precedence over individual margins
  if (mx !== undefined) {
    style.marginLeft = mx;
    style.marginRight = mx;
  } else {
    if (ml !== undefined) style.marginLeft = ml;
    if (mr !== undefined) style.marginRight = mr;
  }

  if (my !== undefined) {
    style.marginTop = my;
    style.marginBottom = my;
  } else {
    if (mt !== undefined) style.marginTop = mt;
    if (mb !== undefined) style.marginBottom = mb;
  }

  return <div className={clsx(styles.skeleton, className)} style={style} />;
};

export default Skeleton;
